import React, { Component } from 'react';
import PropTypes from "prop-types";
import { metadataService } from "../../_services";

export class PaymentBreakdown extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <tbody className="border-top-0 font-size-16">
                {this.props.breakdownType === 'payment' && this.props.loan.nextPaymentAmount > 0 &&
                    <tr>
                        <td className="border-right-0 pl-5">
                            {metadataService.getFieldNameLabel("ScheduledMonthlyPayment")}
                        </td>
                        <td className="border-left-0 pl-5">
                            {metadataService.formatMoney(this.props.loan.nextPaymentAmount)}
                        </td>
                    </tr>
                }
                {this.props.breakdownType === 'payment' ?
                    <tr>
                        <td className="border-right-0 pl-5">
                            {metadataService.getFieldNameLabel("PaymentsDue")}
                        </td>
                        <td className="border-left-0 pl-5">
                            {metadataService.formatMoney(this.props.loan.paymentsDue)}
                        </td>
                    </tr>
                    :
                    <tr>
                        <td className="border-right-0 pl-5">
                            {metadataService.getFieldNameLabel("Balance")}
                        </td>
                        <td className="border-left-0 pl-5">
                            {metadataService.formatMoney(this.props.loan.balance)}
                        </td>
                    </tr>
                }

                { this.props.breakdownType === 'payoff' && this.props.loan.payoffRefunds > 0 && (
                    <tr>
                        <td className="border-right-0 pl-5">
                            {metadataService.getFieldNameLabel("Refunds")}
                        </td>
                        <td className="border-left-0 pl-5">
                            {this.props.breakdownType === 'payoff' && <span> - </span>}
                            {metadataService.formatMoney(this.props.loan.payoffRefunds)}
                        </td>
                    </tr>
                )}

                {this.props.breakdownType === 'payoff' && this.props.loan.interestDue > 0 && (
                    <tr>
                        <td className="border-right-0 pl-5">
                            {metadataService.getFieldNameLabel("InterestDue")}
                        </td>
                        <td className="border-left-0 pl-5">
                            <span> + </span>
                            {metadataService.formatMoney(this.props.loan.interestDue)}
                        </td>
                    </tr>
                )}
                {this.props.loan.lateChargesDue > 0 && (
                    <tr>
                        <td className="border-right-0 pl-5">
                            {metadataService.getFieldNameLabel("LateChargesDue")}
                        </td>
                        <td className="border-left-0 pl-5">
                            {this.props.breakdownType === 'payoff' && <span> + </span>}
                            {metadataService.formatMoney(this.props.loan.lateChargesDue)}
                        </td>
                    </tr>
                )}
                {this.props.loan.nsfChargeDue > 0 && (
                    <tr>
                        <td className="border-right-0 pl-5">
                            {metadataService.getFieldNameLabel("NSFChargeDue")}
                        </td>
                        <td className="border-left-0 pl-5">
                            {this.props.breakdownType === 'payoff' && <span> + </span>}
                            {metadataService.formatMoney(this.props.loan.nsfChargeDue)}
                        </td>
                    </tr>
                )}
                {this.props.loan.legalChargeDue > 0 && (
                    <tr>
                        <td className="border-right-0 pl-5">
                            {metadataService.getFieldNameLabel("LegalChargeDue")}
                        </td>
                        <td className="border-left-0 pl-5">
                            {this.props.breakdownType === 'payoff' && <span> + </span>}
                            {metadataService.formatMoney(this.props.loan.legalChargeDue)}
                        </td>
                    </tr>
                )}
                {this.props.loan.additionalChargeDue > 0 && (
                    <tr>
                        <td className="border-right-0 pl-5">
                            {metadataService.getFieldNameLabel("AdditionalChargeDue")}
                        </td>
                        <td className="border-left-0 pl-5">
                            {this.props.breakdownType === 'payoff' && <span> + </span>}
                            {metadataService.formatMoney(this.props.loan.additionalChargeDue)}
                        </td>
                    </tr>
                )}
            </tbody>
        )
    }
}

PaymentBreakdown.propTypes = {
    loan: PropTypes.object.isRequired,
    breakdownType: PropTypes.oneOf(['payment', 'payoff'])
}

PaymentBreakdown.defaultProps = {
    breakdownType: 'payment'
}